import { getApiClient } from "@punchup/utils";
import { CollectionRow } from "../../models/collections";

export type CreateCollectionParams = {
  name: string;
  description?: string;
  comedian_id: string;
  requires_purchase?: boolean;
  requires_subscription?: boolean;
  subscription_product_id?: string | null;
};

export type UpdateCollectionParams = {
  name?: string;
  slug?: string;
  description?: string;
  requires_subscription?: boolean;
  requires_purchase?: boolean;
  subscription_product_id?: string | null;
};

export async function getComedianManagerCollections(
  comedianId: string
): Promise<CollectionRow[]> {
  return getApiClient()
    .get<{ data: CollectionRow[] }>(
      `/api/v2/manager/collections?owner_comedian_id=${comedianId}`
    )
    .then((res) => res.data);
}

export async function createManagerCollection(
  params: CreateCollectionParams
): Promise<CollectionRow> {
  return getApiClient()
    .post<{ data: CollectionRow }>("/api/v2/manager/collections", params)
    .then((res) => res.data);
}

export async function updateManagerCollection(
  collectionId: string,
  params: UpdateCollectionParams
): Promise<CollectionRow> {
  return getApiClient()
    .patch<{ data: CollectionRow }>(
      `/api/v2/manager/collections/${collectionId}`,
      params
    )
    .then((res) => res.data);
}

export async function publishManagerCollection(
  collectionId: string
): Promise<CollectionRow> {
  return getApiClient()
    .post<{ data: CollectionRow }>(
      `/api/v2/manager/collections/${collectionId}/publish`
    )
    .then((res) => res.data);
}

export async function addVideosToCollection(
  collectionId: string,
  specialIds: string[]
): Promise<void> {
  await getApiClient().post(
    `/api/v2/manager/collections/${collectionId}/videos`,
    { special_ids: specialIds }
  );
}
